<template>
    <div class="page-dashboard">
        <preloader v-if="isLoading"></preloader>
        <h1>Dashboard</h1>
        <p>Hai, perkenalkan saya Amy asisten pribadi untuk bisnis Anda. Kalau kamu baru pertama kali kesini, ikuti langkah dibawah ini untuk panduan memulai.</p>

        <div v-for="(step, index) in values.steps" :key="step.label">
            <div v-if="!step.is_finished" :class="step.is_finished ? 'step finished' : 'step'">
                <div class="meta">
                    <h3 class="section-label index">{{ index + 1 }}.</h3>
                </div>
                <div class="description">
                    <h3 class="section-label">{{ step.label }}</h3>
                    <p>{{ step.description }}</p>
                    <a :href="step.cta_action">{{ step.cta_label }}</a>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import Preloader from "../Preloader.vue";
export default {
    components:{
        Preloader
    },
    data: function() {
        return {
            values: {},
        };
    },
    beforeMount: async function() {
		this.getServices();
	},
    methods: {
        async getServices() {
            this.isLoading = true;
			try {
				const response = await axios.get(`/dashboards`);
                this.values = { ...response.data };
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
    },
}
</script>